module.exports = __webpack_public_path__ + "static/src/content/images/processed/200/Underdog-2007.f36d4f7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/content/images/processed/200/Underdog-2007.jpg
// module id = aT+D
// module chunks = 0